import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M512 51.2a460.8 460.8 0 1 1 0 921.6 460.8 460.8 0 1 1 0-921.6zm152.78 499.2H359.22C367.717 746.394 440.063 896 512 896s144.282-149.606 152.78-345.6zm-382.463 0H129.946a384.358 384.358 0 0 0 231.168 314.778c-45.261-77.159-73.882-189.287-78.695-314.778zm611.789 0H741.632c-4.813 125.491-33.434 237.62-78.694 314.778A384.256 384.256 0 0 0 894.106 550.4zM361.114 158.822l-4.301 1.844A384.154 384.154 0 0 0 129.946 473.6h152.422c4.864-125.491 33.485-237.62 78.746-314.778zM512 128l-2.867.102C438.17 131.994 367.616 280.218 359.219 473.6h305.562C656.28 277.606 583.936 128 512 128zm150.938 30.822 2.816 4.864c43.622 76.954 71.168 187.034 75.878 309.914h152.422a384.307 384.307 0 0 0-231.116-314.829z" /></svg>

const Lang = React.forwardRef((props, ref) => {
  return (
    <IconBase name="lang" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Lang.displayName = 'IconLang'

export default Lang
